import { getUser } from "@/services/StorageService";
import { useAuthenticationStore } from "@/stores/authentication";
import { AxiosRequestConfig } from "axios";
import { http } from "@/services/HttpService";

export const authMiddleware = async (to: any, from: any, next: any): Promise<void> => {
    const authenticationStore = useAuthenticationStore();
    // Si no esta autenticado y se intenta acceder a una ruta que requiere autenticacion, se redirige a la pagina de login
    if (to.meta.requiresAuth && !authenticationStore.isAuthenticated) {
        next('/login');
    }
    if (authenticationStore.isAuthenticated) {
        http.http.interceptors.request.use((config: AxiosRequestConfig): AxiosRequestConfig => {
            try {
                const token = authenticationStore.user?.api_token ?? null;

                if (token != null && config && config.headers) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
                return config;
            } catch (error: any) {
                throw new Error(error);
            }
        }, (error) => Promise.reject(error));
    }

    next();
};

export const autoLogin = async (to: any, from: any, next: any): Promise<void> => {
    const authenticationStore = useAuthenticationStore();
    //Se buscan los datos del store de autenticacion sino se buscan en el storage para meterlos en el store
    if (!authenticationStore.user) {
        const user = await getUser();
        if (user) {
            authenticationStore.setUser(user);
        }
    }
    next();
};

export const avoidLogin = async (to: any, from: any, next: any): Promise<void> => {
    const authenticationStore = useAuthenticationStore();
    //Si está logueado y quiere ir a la página de login, lo redirige a la página principal
    if (authenticationStore.isAuthenticated) {
        next('/home');
    }

    next();
}